import { Injectable } from '@angular/core';
import { SearchDrawingsPendingHaulageFilters } from '@app/infrastructure/api/models';
import { ROWS_PER_PAGE_OPTIONS } from '@app/shared/common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetDrawingsPendingHaulageListConfig } from './_actions';

export const CURRENT_DRAWINGS_PENDING_HAULAGE_LIST_VERSION = 1;

interface DrawingsPendingHaulageListStateModel {
  version: number;
  searchText?: string;
  itemsPerPage: number;
  filters?: SearchDrawingsPendingHaulageFilters;
}

export const DRAWINGS_PENDING_HAULAGE_LIST_STATE_DEFAULTS: DrawingsPendingHaulageListStateModel = {
  version: CURRENT_DRAWINGS_PENDING_HAULAGE_LIST_VERSION,
  itemsPerPage: ROWS_PER_PAGE_OPTIONS[0],
};

@State<DrawingsPendingHaulageListStateModel>({
  name: 'DrawingsPendingHaulageList',
  defaults: DRAWINGS_PENDING_HAULAGE_LIST_STATE_DEFAULTS,
})
@Injectable()
export class DrawingsPendingHaulageListState {
  @Selector()
  static itemsPerPage(state: DrawingsPendingHaulageListStateModel): number {
    return state.itemsPerPage;
  }

  @Selector()
  static filters(
    state: DrawingsPendingHaulageListStateModel,
  ): SearchDrawingsPendingHaulageFilters | undefined {
    return state.filters;
  }

  @Selector()
  static searchText(state: DrawingsPendingHaulageListStateModel): string | undefined {
    return state.searchText;
  }

  @Action(SetDrawingsPendingHaulageListConfig)
  setListConfig(
    ctx: StateContext<DrawingsPendingHaulageListStateModel>,
    action: SetDrawingsPendingHaulageListConfig,
  ) {
    ctx.patchState({
      itemsPerPage: action.config.pagination.itemsPerPage as number,
      filters: action.config.filters || undefined,
      searchText: action.config.searchText || undefined,
    });
  }
}
